import React, { useCallback, useState } from 'react'
import type { GiftCard, GiftCardRecipient } from 'api/api.types'
import { AppButton } from 'components/FormElements/AppButton/AppButton'
import { Modal } from 'components/Utility/Modal/Modal'
import { CertificateRecipientForm } from 'components/Forms/CertificateRecipientForm/CertificateRecipientForm'
import type { CartItem } from './types'
import styles from './GiftCardsPage.module.scss'

const EMPTY_RECIPIENT: GiftCardRecipient = { email: '', name: '', phone: '' }

type GiftCardsListProps = {
  certificates: Array<{ card: GiftCard }>,
  onSelected: (item: CartItem) => void,
}

/** The card designs; buying one asks for the recipient first */
export const GiftCardsList: React.FC<GiftCardsListProps> = ({ certificates, onSelected }) => {
  const [selected, setSelected] = useState<GiftCard | null>(null)

  const handleSubmitRecipient = useCallback((recipient: GiftCardRecipient) => {
    if (selected) {
      onSelected({ certificate: selected, amount: 1, recipient })
    }
    setSelected(null)
  }, [selected, onSelected])

  return (
    <div className={styles.certificates}>
      {certificates.map(({ card }) => (
        <div key={card.id} className={styles.certificateContainer} onClick={() => setSelected(card)}>
          <div className={styles.certificateImageContainer}>
            <img alt={card.name} className={styles.certificateImage} src={card.image} />
          </div>
          <AppButton>Купить</AppButton>
        </div>
      ))}
      {selected && (
        <Modal title={'Кому отправляем сертификат?'} isOpen onClose={() => setSelected(null)}>
          <CertificateRecipientForm onSubmit={handleSubmitRecipient} data={EMPTY_RECIPIENT} />
        </Modal>
      )}
    </div>
  )
}
